

































import { defineComponent, PropType } from "@vue/composition-api"

// hooks
import useMaskId from "./useMaskId"

// components
import PopupBox from "../PopupBox.vue"

export default defineComponent({
  name: "MaskId",
  components: {
    PopupBox
  },
  props: {
    init: {
      // eslint-disable-next-line no-unused-vars
      type: Function as PropType<(doModuleGetLoginState: boolean, _getLoginState?: (() => Promise<any>) | undefined) => Promise<void>>,
      required: true
    },
    showAppleAuth: {
      type: Function as PropType<() => void>,
      required: true
    }
  },
  setup(props) {
    const maskId = useMaskId(props)
    return maskId
  }
})
